import React, {useEffect, useState} from 'react'
import _ from "lodash";
import {DocumentArrowUpIcon} from "@heroicons/react/24/solid";
import {addQuotes, updateSingleQuote} from "../common/services/quote-data-service";
import ShowMessage from "../common/ui/show-message";
import {prepareTextListForSearch} from "../common/utils/text-util";
import SelectThemes from "../theme/components/select-themes";
import SelectTags from "../tag/select-tags";
import {searchThemes} from "../theme/services/theme-data-service";
import {searchTags} from "../common/services/tag-data-service";


const AddQuoteDetails = () => {
    const [initialStep, setInitialStep] = useState(true);
    const [isSuccess, setIsSuccess] = useState(false);
    const [isError, setIsError] = useState(false);
    const [inputText, setInputText] = useState('');
    const [textItemList, setTextItemList] = useState([]);
    const [allThemes, setAllThemes] = useState([]);
    const [allTags, setAllTags] = useState([]);
    const [selectedThemes, setSelectedThemes] = useState([]);
    const [selectedTags, setSelectedTags] = useState([]);
    const [selectedDetail, setSelectedDetail] = useState({
        themes: {},
        themeList: [],
        tags: {},
        tagList: [],
    });

    useEffect(() => {
        getThemesList();
        getTagsList();
    }, [initialStep]);

    const getThemesList = async () => {
        const themesListResult = await searchThemes('')
        setAllThemes(themesListResult);
    }

    const getTagsList = async () => {
        const tagsListResult = await searchTags('');
        setAllTags(tagsListResult);
    }

    const handleThemeTagChanges = async (event) => {
        const {name, value} = event.target;
        const existingSelectedDetail = {...selectedDetail};
        existingSelectedDetail[name] = value;

        if (name === 'themeList') {
            const tempThemes = {};
            _.forEach(value, themeId => {
                tempThemes[themeId] = true;
            });

            existingSelectedDetail['themes'] = tempThemes;
            existingSelectedDetail['themeList'] = value;
        }

        if (name === 'tagList') {
            const tempTags = {};
            _.forEach(value, tagId => {
                tempTags[tagId] = true;
            });

            existingSelectedDetail['tags'] = tempTags;
            existingSelectedDetail['tagList'] = value;
        }

        setSelectedDetail(existingSelectedDetail);
    }

    const handleInputTextChange = (newValue) => {
        setInputText(newValue);

        const inputTextItems = _.split(newValue, '\n');
        const tempTextItemList = [];

        _.forEach(inputTextItems, (text, index) => {
            text = text.trim();

            if (text) {
                let changedText = _.startCase(text);
                let textList = prepareTextListForSearch(text);

                tempTextItemList.push({
                    text: text,
                    textList: textList,
                    startText: changedText,
                    displayText: changedText
                });
            }
        });

        setTextItemList(tempTextItemList);
    };

    const saveQuotes = async () => {
        const existingSelectedDetail = {...selectedDetail};
        const newTextItemList = [...textItemList];

        _.forEach(newTextItemList, (textItem, index) => {
            textItem.tags = existingSelectedDetail.tags;
            textItem.tagList = existingSelectedDetail.tagList;
            textItem.themes = existingSelectedDetail.themes;
            textItem.themeList = existingSelectedDetail.themeList;
        });
        console.log({newTextItemList})
        await addQuotes(newTextItemList);
        setIsSuccess(true);
    }

    return (
        <>

            <div className="m-8">
                <ShowMessage
                    isSuccess={isSuccess}
                    isError={isError}
                    message={'Quotes Added Successfully.'}/>
            </div>

            <div className="flex justify-center m-8 bg-gray-200 rounded quotes-container">

                <div className="items-center justify-start w-1/2 p-8">
                    <div className="w-full mb-8">
                        <div className="font-bold">Quotes</div>
                    </div>
                    <textarea
                        id="inputText"
                        name="inputText"
                        value={inputText}
                        onChange={(event) => handleInputTextChange(event.target.value)}
                        className="w-full quotes-input-container border border-slate-400 rounded p-2"/>

                    <div>
                        {allThemes?.length > 0 &&
                            <div
                                className="h-40 overflow-y-scroll border-gray-400 border bg-blue-50 mb-4 rounded mt-3">
                                <SelectThemes
                                    existingThemes={selectedDetail?.themeList}
                                    allThemes={allThemes}
                                    handleSelectThemesChanges={handleThemeTagChanges}
                                    showClearSelectedThemes={false}
                                    showClearSelectedThemesIcon={false}/>
                            </div>
                        }
                    </div>

                    <div>
                        {allTags?.length > 0 &&
                            <div
                                className="h-80 overflow-y-scroll border-gray-400 border bg-blue-50 mb-4 rounded mt-2 shadow-xl">
                                <SelectTags
                                    existingTags={selectedDetail?.tagList}
                                    allTags={allTags}
                                    handleSelectTagsChanges={handleThemeTagChanges}
                                    showAddTag="true"
                                    showClearSelectedTags={false}
                                    showClearSelectedTagsIcon={false}/>
                            </div>
                        }
                    </div>
                </div>

                <div
                    className="items-center justify-start overflow-y-scroll prepared-quotes-container w-1/2 pb-16 mr-8 my-8">

                    <div className="flex items-center w-full mb-4">
                        <div className="font-bold">Prepare Quotes</div>
                        <div className="ml-4">
                            <button
                                onClick={() => {
                                    saveQuotes()
                                }}
                                className="rounded flex items-center justify-center bg-green-600 text-white border border-green-600 text-gray-800 h-10 hover:bg-gray-600 hover:text-white">
                                <div className="pl-2">
                                    <DocumentArrowUpIcon className="h-6 w-6"/>
                                </div>
                                <div className="p-2">Save Quotes</div>
                            </button>
                        </div>
                    </div>

                    <div className="overflow-y-scroll h-full border border-gray-400 rounded bg-white px-4">
                        <div className="py-4">
                            {textItemList?.map((textItem, index) => (
                                <div key={index}>
                                    {index !== textItemList?.length - 1 ?
                                        <div className="py-2 border-b border-gray-400"><span
                                            className="px-4 text-gray-600">{index + 1}</span>{textItem.text}
                                        </div>
                                        : <div className="py-2"><span
                                            className="px-4 text-gray-600">{index + 1}</span>{textItem.text}
                                        </div>
                                    }

                                </div>
                            ))}
                        </div>
                    </div>

                </div>

            </div>

        </>
    )
}

export default AddQuoteDetails
